import { useMemo } from 'react';
import { usePostHog } from 'posthog-js/react';
import { PostHogInstance } from 'shared/posthogCapture/types';

export const createOnboardingCaptureEvents = (posthog: PostHogInstance) => ({
  captureContinued: () => {
    posthog?.capture('onboarding / capture / continued');
  },
  notificationsAllowed: () => {
    posthog?.capture('onboarding / notifications / allowed');
  },
  notificationsSkipped: () => {
    posthog?.capture('onboarding / notifications / skipped');
  },
  privacyLearnMoreOpened: () => {
    posthog?.capture('onboarding / privacy / learn more opened');
  },
  privacyAccepted: () => {
    posthog?.capture('onboarding / privacy / accepted');
  },
});

export type OnboardingCaptureEvents = ReturnType<
  typeof createOnboardingCaptureEvents
>;

export const usePosthogCapture = () => {
  const posthog = usePostHog();
  return useMemo(() => createOnboardingCaptureEvents(posthog), [posthog]);
};
